import { useCallback, useState } from 'react';
import { useAcLedMappingPost } from 'actions/ac-led-mapping';
import { useDispatch } from 'react-redux';
import { closeModal } from 'actions/modal';
import { AC_LED_MAPPING_EVENTS } from 'constants/ac-led-mapping';
import moment from 'moment';
import { showNotification } from 'actions/notification';
import { formatErrorMessage } from 'utils';

const useLogic = ({
  teacherID,
  timezone,
  prospectID,
  selectedDate,
  inputTime = null,
}) => {
  const [time, setTime] = useState(inputTime || moment().format('HH:mm'));
  const [error, setError] = useState('');
  const dispatch = useDispatch();

  const handleBookTrialClassComplete = (errorMessage, data) => {
    if (errorMessage) {
      dispatch(
        showNotification({
          text: formatErrorMessage(errorMessage),
          duration: 10,
          showCloseIcon: true,
        }),
      );
    } else if (data?.event_payload?.response) {
      const { message } = data?.event_payload?.response;
      if (message) {
        setError(message);
      } else {
        dispatch(
          showNotification({
            text: 'Trial class booked successfully',
            duration: 10,
            showCloseIcon: true,
          }),
        );
        dispatch(closeModal());
      }
    }
  };

  const {
    post: bookTrialClass,
    isProcessing: isBookTrialClassProcessing,
  } = useAcLedMappingPost({
    onComplete: handleBookTrialClassComplete,
  });

  const handleChange = val => {
    setTime(val);
    setError('');
  };

  const handleBookTrialClass = () => {
    const body = {
      prospect_id: prospectID,
      event_name: AC_LED_MAPPING_EVENTS.BOOK_DEMO_SLOT,
      event_payload: {
        datetime: `${selectedDate} ${time}`,
        timezone,
        teacher_id: teacherID,
      },
    };
    bookTrialClass(body);
  };

  const isSubmitDisabled = !time || error;

  const getSubmitButtonLabel = useCallback(() => {
    const startTime = moment(time, 'HH:mm');
    const endTime = moment(time, 'HH:mm').add(55, 'minutes');
    const formattedTime = `${moment(startTime).format('hh:mm A')}-${moment(
      endTime,
    ).format('hh:mm A')}`;

    return `Book Trial Class for ${formattedTime}`;
  }, [time]);

  const buttonLabel = time ? getSubmitButtonLabel() : 'Book Trial Class';

  return {
    time,
    handleChange,
    error,
    isSubmitDisabled,
    handleBookTrialClass,
    isBookTrialClassProcessing,
    buttonLabel,
  };
};

export default useLogic;
